import { render, staticRenderFns } from "./AssetMarker.vue?vue&type=template&id=4a4033d8&"
import script from "./AssetMarker.vue?vue&type=script&lang=js&"
export * from "./AssetMarker.vue?vue&type=script&lang=js&"
import style0 from "./AssetMarker.vue?vue&type=style&index=0&id=4a4033d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports